import React, { useMemo } from 'react'
import { IQuestionInfo } from '@linqpal/models'
import { ProjectSections } from '@linqpal/models/src/dictionaries'
import { QuestionTitle } from './components'
import ProjectStore from './Store'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'

interface QuestionProps {
  section?: ProjectSections
  question: IQuestionInfo
}

export const Question: React.FC<QuestionProps> = observer(
  ({ section, question }) => {
    const { model, formData } = ProjectStore
    const value = useMemo(() => {
      return formData?.data
        ?.get(section || '')
        ?.items?.find((i) => i.identifier === question.identifier)?.content
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toJS(formData?.data), question.identifier, section])

    const uu = model(section, question)

    return (
      <>
        {!!question.title && (
          <QuestionTitle title={question.title} subtitle={question.subtitle} />
        )}
        <question.component model={uu} value={value} />
      </>
    )
  },
)
